(function () {
  function initNavigation() {
    var nav = document.getElementById('SiteNav');
    var navToggle = document.querySelector('[data-nav-toggle]');

    if (!nav || !navToggle || nav.getAttribute('data-nav-init') === 'true') {
      return;
    }

    nav.setAttribute('data-nav-init', 'true');

    var submenuButtons = nav.querySelectorAll('[data-submenu-toggle]');
    var submenuCloseTimers = new WeakMap();

    function isDesktopNav() {
      return window.innerWidth > 1024;
    }

    function closeAllSubmenus(except) {
      submenuButtons.forEach(function (button) {
        var item = button.closest('.site-nav__item');
        if (!item || item === except) {
          return;
        }

        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      });
    }

    function setNavOpen(isOpen) {
      document.body.classList.toggle('nav-open', isOpen);
      navToggle.setAttribute('aria-expanded', String(isOpen));
      if (!isOpen) {
        closeAllSubmenus();
      }
    }

    navToggle.addEventListener('click', function () {
      setNavOpen(!document.body.classList.contains('nav-open'));
    });

    submenuButtons.forEach(function (button) {
      var item = button.closest('.site-nav__item');
      if (item) {
        item.addEventListener('mouseenter', function () {
          if (!isDesktopNav()) {
            return;
          }

          var closeTimer = submenuCloseTimers.get(item);
          if (closeTimer) {
            window.clearTimeout(closeTimer);
            submenuCloseTimers.delete(item);
          }

          closeAllSubmenus(item);
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        });

        item.addEventListener('mouseleave', function () {
          if (!isDesktopNav()) {
            return;
          }

          var timer = window.setTimeout(function () {
            item.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
            submenuCloseTimers.delete(item);
          }, 180);

          submenuCloseTimers.set(item, timer);
        });
      }

      button.addEventListener('click', function () {
        var buttonItem = button.closest('.site-nav__item');
        if (!buttonItem) {
          return;
        }

        var closeTimer = submenuCloseTimers.get(buttonItem);
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          submenuCloseTimers.delete(buttonItem);
        }

        var next = !buttonItem.classList.contains('is-open');
        closeAllSubmenus(buttonItem);
        buttonItem.classList.toggle('is-open', next);
        button.setAttribute('aria-expanded', String(next));
      });
    });

    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target) && !navToggle.contains(event.target)) {
        closeAllSubmenus();
        setNavOpen(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllSubmenus();
        setNavOpen(false);
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) {
        closeAllSubmenus();
        setNavOpen(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavigation);
  } else {
    initNavigation();
  }

  document.addEventListener('shopify:section:load', initNavigation);
})();

(function () {
  function initGallery(gallery) {
    if (!gallery || gallery.getAttribute('data-gallery-initialized') === 'true') {
      return;
    }

    gallery.setAttribute('data-gallery-initialized', 'true');

    var mainImage = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var mediaMain = gallery.querySelector('.nh-pdp__media-main');
    var lightbox = gallery.querySelector('[data-gallery-lightbox]');
    var lightboxImage = gallery.querySelector('[data-gallery-lightbox-image]');
    var lightboxPrevButton = gallery.querySelector('[data-gallery-lightbox-prev]');
    var lightboxNextButton = gallery.querySelector('[data-gallery-lightbox-next]');
    var openButton = gallery.querySelector('[data-gallery-open]');
    var closeButtons = gallery.querySelectorAll('[data-gallery-close]');
    var prevButton = gallery.querySelector('[data-gallery-prev]');
    var nextButton = gallery.querySelector('[data-gallery-next]');
    var touchStartX = null;
    var suppressZoomOpen = false;

    if (!mainImage) {
      return;
    }

    function setActiveThumb(selectedThumb) {
      thumbs.forEach(function (thumb) {
        var isActive = thumb === selectedThumb;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function swapMainImage(thumb) {
      var mainSrc = thumb.getAttribute('data-main-src');
      var mainSrcset = thumb.getAttribute('data-main-srcset');
      var zoomSrc = thumb.getAttribute('data-zoom-src');
      var alt = thumb.getAttribute('data-alt') || '';

      if (mainSrc) {
        mainImage.setAttribute('src', mainSrc);
      }
      if (mainSrcset) {
        mainImage.setAttribute('srcset', mainSrcset);
      }
      if (zoomSrc) {
        mainImage.setAttribute('data-zoom-src', zoomSrc);
      }

      mainImage.setAttribute('alt', alt);
      setActiveThumb(thumb);
    }

    function getActiveThumbIndex() {
      var activeIndex = 0;

      thumbs.forEach(function (thumb, index) {
        if (thumb.classList.contains('is-active')) {
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function moveGalleryBy(step) {
      if (!thumbs.length) {
        return;
      }

      var currentIndex = getActiveThumbIndex();
      var nextIndex = (currentIndex + step + thumbs.length) % thumbs.length;
      swapMainImage(thumbs[nextIndex]);
    }

    function syncLightboxImageWithMain() {
      if (!lightboxImage) {
        return;
      }

      var zoomSrc = mainImage.getAttribute('data-zoom-src') || mainImage.getAttribute('src');
      lightboxImage.setAttribute('src', zoomSrc);
      lightboxImage.setAttribute('alt', mainImage.getAttribute('alt') || '');
    }

    function closeLightbox() {
      if (!lightbox) {
        return;
      }

      lightbox.hidden = true;
      document.body.classList.remove('nh-lightbox-open');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swapMainImage(thumb);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        moveGalleryBy(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        moveGalleryBy(1);
      });
    }

    if (mediaMain && thumbs.length > 1) {
      mediaMain.addEventListener('touchstart', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        touchStartX = touch ? touch.clientX : null;
      });

      mediaMain.addEventListener('touchend', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch || touchStartX === null) {
          return;
        }

        var deltaX = touch.clientX - touchStartX;
        touchStartX = null;

        if (Math.abs(deltaX) > 40) {
          suppressZoomOpen = true;
          moveGalleryBy(deltaX > 0 ? -1 : 1);
          window.setTimeout(function () {
            suppressZoomOpen = false;
          }, 260);
        }
      });
    }

    if (openButton && lightbox && lightboxImage) {
      openButton.addEventListener('click', function () {
        if (suppressZoomOpen) {
          return;
        }

        syncLightboxImageWithMain();
        lightbox.hidden = false;
        document.body.classList.add('nh-lightbox-open');
      });

      if (lightboxPrevButton) {
        lightboxPrevButton.addEventListener('click', function (event) {
          event.preventDefault();
          moveGalleryBy(-1);
          syncLightboxImageWithMain();
        });
      }

      if (lightboxNextButton) {
        lightboxNextButton.addEventListener('click', function (event) {
          event.preventDefault();
          moveGalleryBy(1);
          syncLightboxImageWithMain();
        });
      }

      closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener('click', closeLightbox);
      });

      document.addEventListener('keydown', function (event) {
        if (lightbox.hidden) {
          return;
        }

        if (event.key === 'Escape') {
          closeLightbox();
        } else if (event.key === 'ArrowLeft') {
          moveGalleryBy(-1);
          syncLightboxImageWithMain();
        } else if (event.key === 'ArrowRight') {
          moveGalleryBy(1);
          syncLightboxImageWithMain();
        }
      });
    }
  }

  function initAllGalleries(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll('[data-product-gallery]');

    galleries.forEach(function (gallery) {
      initGallery(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllGalleries(document);
    });
  } else {
    initAllGalleries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllGalleries(event.target);
  });
})();

(function () {
  function initQuickView() {
    if (!document.body || document.body.getAttribute('data-qv-initialized') === 'true') {
      return;
    }

    var modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) {
      return;
    }

    document.body.setAttribute('data-qv-initialized', 'true');

    var closeButtons = modal.querySelectorAll('[data-quick-view-close]');
    var image = modal.querySelector('[data-qv-image]');
    var imageWrap = modal.querySelector('.nh-quick-view__image-wrap');
    var prevImageButton = modal.querySelector('[data-qv-prev]');
    var nextImageButton = modal.querySelector('[data-qv-next]');
    var vendor = modal.querySelector('[data-qv-vendor]');
    var title = modal.querySelector('[data-qv-title]');
    var price = modal.querySelector('[data-qv-price]');
    var compare = modal.querySelector('[data-qv-compare]');
    var viewLink = modal.querySelector('[data-qv-view]');
    var addButton = modal.querySelector('[data-qv-add]');
    var quickViewImages = [];
    var quickViewImageIndex = 0;
    var qvTouchStartX = null;

    function closeQuickView() {
      modal.hidden = true;
      document.body.classList.remove('nh-quick-view-open');
    }

    function renderQuickViewImage() {
      var activeImageUrl = quickViewImages[quickViewImageIndex] || '';

      if (activeImageUrl) {
        image.setAttribute('src', activeImageUrl);
        image.style.display = '';
      } else {
        image.removeAttribute('src');
        image.style.display = 'none';
      }

      if (prevImageButton && nextImageButton) {
        var hasMultipleImages = quickViewImages.length > 1;
        prevImageButton.hidden = !hasMultipleImages;
        nextImageButton.hidden = !hasMultipleImages;
      }
    }

    function moveQuickViewImage(step) {
      if (quickViewImages.length <= 1) {
        return;
      }

      quickViewImageIndex = (quickViewImageIndex + step + quickViewImages.length) % quickViewImages.length;
      renderQuickViewImage();
    }

    function openQuickView(card) {
      if (!card) {
        return;
      }

      var productTitle = card.getAttribute('data-qv-title') || '';
      var productVendor = card.getAttribute('data-qv-vendor') || '';
      var productUrl = card.getAttribute('data-qv-url') || '#';
      var productImage = card.getAttribute('data-qv-image') || '';
      var productImagesRaw = card.getAttribute('data-qv-images') || '';
      var productPrice = card.getAttribute('data-qv-price') || '';
      var productCompare = card.getAttribute('data-qv-compare') || '';
      var variantId = card.getAttribute('data-qv-variant-id') || '';
      var available = card.getAttribute('data-qv-available') === 'true';

      quickViewImages = productImagesRaw
        .split('||')
        .map(function (item) {
          return item.trim();
        })
        .filter(function (item) {
          return item.length > 0;
        });

      if (!quickViewImages.length && productImage) {
        quickViewImages = [productImage];
      }

      title.textContent = productTitle;
      vendor.textContent = productVendor;
      price.textContent = productPrice;
      compare.textContent = productCompare;
      compare.style.display = productCompare ? '' : 'none';
      viewLink.setAttribute('href', productUrl);
      image.setAttribute('alt', productTitle);

      quickViewImageIndex = 0;
      renderQuickViewImage();

      modal.setAttribute('data-qv-variant-id', variantId);
      addButton.disabled = !available || !variantId;
      addButton.textContent = available ? 'Add to cart' : 'Sold out';

      modal.hidden = false;
      document.body.classList.add('nh-quick-view-open');
    }

    function updateCartCount(byAmount) {
      var cartCountNodes = document.querySelectorAll('.site-actions__count');

      cartCountNodes.forEach(function (node) {
        var current = parseInt(node.textContent || '0', 10);
        var next = isNaN(current) ? byAmount : current + byAmount;
        node.textContent = String(next);
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-view-trigger]');
      if (!trigger) {
        return;
      }

      event.preventDefault();
      var card = trigger.closest('.product-card');
      openQuickView(card);
    });

    if (prevImageButton) {
      prevImageButton.addEventListener('click', function (event) {
        event.preventDefault();
        moveQuickViewImage(-1);
      });
    }

    if (nextImageButton) {
      nextImageButton.addEventListener('click', function (event) {
        event.preventDefault();
        moveQuickViewImage(1);
      });
    }

    if (imageWrap) {
      imageWrap.addEventListener('touchstart', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        qvTouchStartX = touch ? touch.clientX : null;
      });

      imageWrap.addEventListener('touchend', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch || qvTouchStartX === null) {
          return;
        }

        var deltaX = touch.clientX - qvTouchStartX;
        qvTouchStartX = null;

        if (Math.abs(deltaX) > 40) {
          moveQuickViewImage(deltaX > 0 ? -1 : 1);
        }
      });
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        var variantId = parseInt(modal.getAttribute('data-qv-variant-id') || '', 10);
        if (!variantId || addButton.disabled) {
          return;
        }

        addButton.disabled = true;
        addButton.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to add to cart');
            }
            return response.json();
          })
          .then(function () {
            updateCartCount(1);
            addButton.textContent = 'Added';
            window.setTimeout(function () {
              addButton.textContent = 'Add to cart';
              addButton.disabled = false;
            }, 900);
          })
          .catch(function () {
            addButton.textContent = 'Unavailable';
            window.setTimeout(function () {
              addButton.textContent = 'Add to cart';
              addButton.disabled = false;
            }, 1200);
          });
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeQuickView);
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) {
        return;
      }

      if (event.key === 'Escape') {
        closeQuickView();
      } else if (event.key === 'ArrowLeft') {
        moveQuickViewImage(-1);
      } else if (event.key === 'ArrowRight') {
        moveQuickViewImage(1);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickView);
  } else {
    initQuickView();
  }

  document.addEventListener('shopify:section:load', function () {
    initQuickView();
  });
})();

(function () {
  function initQtyControl(control) {
    if (!control || control.getAttribute('data-qty-initialized') === 'true') {
      return;
    }

    control.setAttribute('data-qty-initialized', 'true');

    var input = control.querySelector('[data-qty-input]');
    var decrease = control.querySelector('[data-qty-decrease]');
    var increase = control.querySelector('[data-qty-increase]');

    if (!input || !decrease || !increase) {
      return;
    }

    function getBounds() {
      return {
        min: parseInt(input.getAttribute('min') || '1', 10),
        max: input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null,
        step: parseInt(input.getAttribute('step') || '1', 10)
      };
    }

    function normalize(value) {
      var bounds = getBounds();
      var nextValue = isNaN(value) ? bounds.min : value;

      if (nextValue < bounds.min) {
        nextValue = bounds.min;
      }
      if (bounds.max !== null && nextValue > bounds.max) {
        nextValue = bounds.max;
      }

      return nextValue;
    }

    function updateBy(delta) {
      var bounds = getBounds();
      var current = normalize(parseInt(input.value || String(bounds.min), 10));
      input.value = String(normalize(current + delta * bounds.step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    decrease.addEventListener('click', function () {
      updateBy(-1);
    });

    increase.addEventListener('click', function () {
      updateBy(1);
    });

    input.addEventListener('change', function () {
      input.value = String(normalize(parseInt(input.value || '0', 10)));
    });
  }

  function initAllQtyControls(root) {
    var scope = root || document;
    var controls = scope.querySelectorAll('[data-qty-control]');

    controls.forEach(function (control) {
      initQtyControl(control);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllQtyControls(document);
    });
  } else {
    initAllQtyControls(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllQtyControls(event.target);
  });
})();

(function () {
  function syncInstagramEmbedFallbacks(scope) {
    var root = scope || document;
    var wraps = root.querySelectorAll('[data-instagram-embed-wrap]');

    wraps.forEach(function (wrap) {
      var fallback = wrap.querySelector('[data-instagram-embed-fallback]');
      if (!fallback) {
        return;
      }

      fallback.hidden = !!wrap.querySelector('iframe');
    });
  }

  function processInstagramEmbeds(scope) {
    var root = scope || document;
    var containsInstagramEmbeds =
      (root.matches && root.matches('[data-instagram-embeds]')) ||
      !!root.querySelector('[data-instagram-embeds]');

    if (!containsInstagramEmbeds) {
      return;
    }

    function runEmbedProcess() {
      if (
        window.instgrm &&
        window.instgrm.Embeds &&
        typeof window.instgrm.Embeds.process === 'function'
      ) {
        window.instgrm.Embeds.process();
        window.requestAnimationFrame(function () {
          syncInstagramEmbedFallbacks(document);
        });
        window.setTimeout(function () {
          syncInstagramEmbedFallbacks(document);
        }, 900);
        window.setTimeout(function () {
          syncInstagramEmbedFallbacks(document);
        }, 2000);
      }
    }

    syncInstagramEmbedFallbacks(root);

    if (window.instgrm && window.instgrm.Embeds) {
      runEmbedProcess();
      return;
    }

    var existingScript = document.querySelector('script[data-instgrm-script]');

    if (existingScript) {
      if (existingScript.getAttribute('data-loaded') === 'true') {
        runEmbedProcess();
      } else {
        existingScript.addEventListener('load', runEmbedProcess, { once: true });
      }
      return;
    }

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.instagram.com/embed.js';
    script.setAttribute('data-instgrm-script', 'true');
    script.addEventListener('load', function () {
      script.setAttribute('data-loaded', 'true');
      runEmbedProcess();
    });
    document.body.appendChild(script);
  }

  function initInstagramEmbeds(scope) {
    processInstagramEmbeds(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initInstagramEmbeds(document);
    });
  } else {
    initInstagramEmbeds(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initInstagramEmbeds(event.target);
  });
})();

(function () {
  function decodePayloadValue(value) {
    var safeValue = value || '';

    try {
      return decodeURIComponent(String(safeValue).replace(/\+/g, '%20'));
    } catch (error) {
      return String(safeValue);
    }
  }

  function parseThemeReviewPayload(rawText) {
    if (!rawText) {
      return null;
    }

    var source = String(rawText).trim();
    var startIndex = source.indexOf('HRV1|');
    if (startIndex === -1) {
      return null;
    }

    source = source.slice(startIndex);
    var parts = source.split('|');
    var data = {};

    for (var i = 1; i < parts.length; i += 1) {
      var part = parts[i];
      var separatorIndex = part.indexOf('=');
      if (separatorIndex === -1) {
        continue;
      }

      var key = part.slice(0, separatorIndex);
      var value = part.slice(separatorIndex + 1);
      data[key] = decodePayloadValue(value);
    }

    if (!data.product_id || !data.text) {
      return null;
    }

    var rating = parseInt(data.rating || '5', 10);
    if (isNaN(rating) || rating < 1) {
      rating = 5;
    }
    if (rating > 5) {
      rating = 5;
    }

    return {
      productId: String(data.product_id),
      productHandle: data.product_handle || '',
      rating: rating,
      image: data.image || '',
      text: data.text
    };
  }

  function textFromNode(node, selectors) {
    var found = '';

    selectors.some(function (selector) {
      var el = node.querySelector(selector);
      if (!el) {
        return false;
      }

      found = (el.textContent || '').trim();
      return found.length > 0;
    });

    return found;
  }

  function parseRating(reviewNode) {
    var ratingValue = 0;
    var ratingMeta = reviewNode.querySelector('meta[itemprop="ratingValue"]');

    if (ratingMeta) {
      ratingValue = parseInt(ratingMeta.getAttribute('content') || '0', 10);
    }

    if (!ratingValue) {
      var ratingAttr =
        reviewNode.getAttribute('data-rating') ||
        reviewNode.getAttribute('data-score') ||
        reviewNode.getAttribute('aria-label') ||
        '';
      var ratingMatch = ratingAttr.match(/[1-5]/);
      ratingValue = ratingMatch ? parseInt(ratingMatch[0], 10) : 0;
    }

    if (!ratingValue) {
      var filledStars = reviewNode.querySelectorAll(
        '.spr-icon-star:not(.spr-icon-star-empty), .jdgm-star.jdgm--on'
      ).length;
      ratingValue = filledStars;
    }

    if (!ratingValue || ratingValue < 1) {
      ratingValue = 5;
    }

    if (ratingValue > 5) {
      ratingValue = 5;
    }

    return ratingValue;
  }

  function parseReviewNode(reviewNode, sourceMeta) {
    var text = textFromNode(reviewNode, [
      '.spr-review-content-body',
      '.spr-review-content',
      '.jdgm-rev__body',
      '[itemprop="description"]'
    ]);

    if (!text) {
      return null;
    }

    var author = textFromNode(reviewNode, [
      '.spr-review-header-byline',
      '.jdgm-rev__author',
      '.reviewer-name',
      '[itemprop="author"]'
    ]);

    var imageNode = reviewNode.querySelector('.spr-review img, .jdgm-rev img, img');
    var image = imageNode ? imageNode.getAttribute('src') || '' : '';
    var rating = parseRating(reviewNode);
    var cleanAuthor = author
      .replace(/^by\s+/i, '')
      .replace(/\s+on\s+.+$/i, '')
      .trim();

    return {
      text: text,
      author: cleanAuthor || 'Verified customer',
      rating: rating,
      image: image,
      productTitle: sourceMeta.productTitle || ''
    };
  }

  function parseThemeReviewSource(templateNode) {
    var parsed = parseThemeReviewPayload(templateNode.getAttribute('data-content') || '');
    if (!parsed) {
      return null;
    }

    return {
      text: parsed.text,
      author: templateNode.getAttribute('data-author') || 'Verified customer',
      rating: parsed.rating,
      image: parsed.image,
      created: templateNode.getAttribute('data-created') || '',
      createdTs: parseInt(templateNode.getAttribute('data-created-ts') || '0', 10),
      productId: parsed.productId,
      productTitle: parsed.productHandle ? parsed.productHandle.replace(/-/g, ' ') : ''
    };
  }

  function collectAutoReviews(section) {
    var sourceWrap = section.querySelector('[data-auto-review-sources]');
    var autoSources = sourceWrap
      ? sourceWrap.querySelectorAll('template[data-auto-review-source]')
      : [];
    var themeSources = sourceWrap
      ? sourceWrap.querySelectorAll('template[data-theme-review-source]')
      : [];
    var parser = new DOMParser();
    var reviews = [];
    var seen = {};

    autoSources.forEach(function (templateNode) {
      var sourceMeta = {
        productTitle: templateNode.getAttribute('data-product-title') || ''
      };
      var html = templateNode.innerHTML || '';
      if (!html.trim()) {
        return;
      }

      var doc = parser.parseFromString(html, 'text/html');
      var reviewNodes = doc.querySelectorAll('.spr-review, .jdgm-rev');

      reviewNodes.forEach(function (reviewNode) {
        var parsed = parseReviewNode(reviewNode, sourceMeta);
        if (!parsed) {
          return;
        }

        var key = (parsed.author + '|' + parsed.text).toLowerCase();
        if (seen[key]) {
          return;
        }

        seen[key] = true;
        reviews.push(parsed);
      });
    });

    themeSources.forEach(function (templateNode) {
      var parsedThemeReview = parseThemeReviewSource(templateNode);
      if (!parsedThemeReview) {
        return;
      }

      var themeKey = (parsedThemeReview.author + '|' + parsedThemeReview.text).toLowerCase();
      if (seen[themeKey]) {
        return;
      }

      seen[themeKey] = true;
      reviews.push(parsedThemeReview);
    });

    return reviews;
  }

  function starsMarkup(rating) {
    var html = '';
    for (var i = 1; i <= 5; i += 1) {
      html += i <= rating ? '&starf;' : '&star;';
    }
    return html;
  }

  function createReviewCard(review) {
    var card = document.createElement('article');
    card.className = 'nh-review-card';

    var stars = document.createElement('div');
    stars.className = 'nh-review-card__stars';
    stars.setAttribute('aria-label', String(review.rating) + ' out of 5 stars');
    stars.innerHTML = starsMarkup(review.rating);
    card.appendChild(stars);

    if (review.image) {
      var photoWrap = document.createElement('div');
      photoWrap.className = 'nh-review-card__photo';
      var photo = document.createElement('img');
      photo.src = review.image;
      photo.alt = review.author + ' review image';
      photo.loading = 'lazy';
      photoWrap.appendChild(photo);
      card.appendChild(photoWrap);
    }

    var body = document.createElement('p');
    body.textContent = review.text;
    card.appendChild(body);

    var author = document.createElement('div');
    author.className = 'nh-review-card__author';
    author.textContent = review.author;
    card.appendChild(author);

    var meta = document.createElement('div');
    meta.className = 'nh-review-card__meta';
    meta.textContent = review.productTitle ? 'Verified review · ' + review.productTitle : 'Verified review';
    card.appendChild(meta);

    return card;
  }

  function hydrateAutoReviews(section) {
    if (
      !section ||
      (section.getAttribute('data-reviews-source') !== 'product_reviews' &&
        section.getAttribute('data-reviews-source') !== 'theme_builtin_reviews')
    ) {
      return;
    }

    var track = section.querySelector('[data-auto-reviews-track]');
    if (!track) {
      return;
    }

    var parsedReviews = collectAutoReviews(section);
    if (!parsedReviews.length) {
      return;
    }

    var limit = parseInt(section.getAttribute('data-reviews-limit') || '10', 10);
    if (isNaN(limit) || limit < 1) {
      limit = 10;
    }

    var layout = section.getAttribute('data-reviews-layout') || 'marquee';
    var renderReviews = parsedReviews.slice(0, limit);

    if (layout === 'marquee') {
      renderReviews = renderReviews.concat(renderReviews);
    }

    track.innerHTML = '';
    renderReviews.forEach(function (review) {
      track.appendChild(createReviewCard(review));
    });
  }

  function initAutoReviewCarousels(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-home-reviews-carousel]');

    sections.forEach(function (section) {
      hydrateAutoReviews(section);
    });
  }

  function createBuiltReviewItem(review) {
    var item = document.createElement('article');
    item.className = 'nh-built-review-item';

    var stars = document.createElement('div');
    stars.className = 'nh-built-review-item__stars';
    stars.setAttribute('aria-label', String(review.rating) + ' out of 5 stars');
    stars.innerHTML = starsMarkup(review.rating);
    item.appendChild(stars);

    if (review.image) {
      var imageWrap = document.createElement('div');
      imageWrap.className = 'nh-built-review-item__image';
      var image = document.createElement('img');
      image.src = review.image;
      image.alt = review.author + ' review image';
      image.loading = 'lazy';
      imageWrap.appendChild(image);
      item.appendChild(imageWrap);
    }

    var text = document.createElement('p');
    text.className = 'nh-built-review-item__text';
    text.textContent = review.text;
    item.appendChild(text);

    var meta = document.createElement('div');
    meta.className = 'nh-built-review-item__meta';
    meta.textContent = review.created ? review.author + ' · ' + review.created : review.author;
    item.appendChild(meta);

    return item;
  }

  function hydrateBuiltProductReviews(root) {
    var scope = root || document;
    var widgets = scope.querySelectorAll('[data-built-reviews]');

    widgets.forEach(function (widget) {
      var productId = String(widget.getAttribute('data-product-id') || '');
      var list = widget.querySelector('[data-built-reviews-list]');
      var summary = widget.querySelector('[data-built-reviews-summary]');
      var empty = widget.querySelector('[data-built-reviews-empty]');
      var sourceNodes = widget.querySelectorAll('template[data-built-review-source]');
      var reviews = [];

      if (!list || !summary || !empty) {
        return;
      }

      sourceNodes.forEach(function (templateNode) {
        var parsed = parseThemeReviewSource(templateNode);
        if (!parsed) {
          return;
        }

        if (String(parsed.productId) !== productId) {
          return;
        }

        reviews.push(parsed);
      });

      reviews.sort(function (a, b) {
        var aTs = isNaN(a.createdTs) ? 0 : a.createdTs;
        var bTs = isNaN(b.createdTs) ? 0 : b.createdTs;
        return bTs - aTs;
      });

      list.innerHTML = '';

      if (!reviews.length) {
        empty.hidden = false;
        summary.innerHTML = '<span>0.0</span> / 5 · 0 reviews';
        return;
      }

      empty.hidden = true;

      var totalRating = 0;
      reviews.forEach(function (review) {
        totalRating += review.rating;
        list.appendChild(createBuiltReviewItem(review));
      });

      var average = totalRating / reviews.length;
      var label = reviews.length === 1 ? 'review' : 'reviews';
      summary.innerHTML = '<span>' + average.toFixed(1) + '</span> / 5 · ' + reviews.length + ' ' + label;
    });
  }

  function initBuiltReviewForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.nh-built-reviews-form');

    forms.forEach(function (form) {
      if (form.getAttribute('data-built-review-init') === 'true') {
        return;
      }

      form.setAttribute('data-built-review-init', 'true');

      form.addEventListener('submit', function (event) {
        var ratingInput = form.querySelector('[data-built-review-rating]');
        var textInput = form.querySelector('[data-built-review-text]');
        var imageInput = form.querySelector('[data-built-review-image]');
        var bodyInput = form.querySelector('[data-built-review-body]');
        var productIdInput = form.querySelector('[data-built-review-product-id]');
        var productHandleInput = form.querySelector('[data-built-review-product-handle]');

        if (!ratingInput || !textInput || !bodyInput || !productIdInput || !productHandleInput) {
          return;
        }

        var rating = (ratingInput.value || '').trim();
        var text = (textInput.value || '').trim();
        if (!rating || !text) {
          event.preventDefault();
          return;
        }

        var image = imageInput ? (imageInput.value || '').trim() : '';
        var payload = [
          'HRV1',
          'product_id=' + encodeURIComponent(productIdInput.value || ''),
          'product_handle=' + encodeURIComponent(productHandleInput.value || ''),
          'rating=' + encodeURIComponent(rating),
          'image=' + encodeURIComponent(image),
          'text=' + encodeURIComponent(text)
        ].join('|');

        bodyInput.value = payload;
      });
    });
  }

  function initReviewsSystem(root) {
    var scope = root || document;
    hydrateBuiltProductReviews(scope);
    initBuiltReviewForms(scope);
    initAutoReviewCarousels(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReviewsSystem(document);
    });
  } else {
    initReviewsSystem(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReviewsSystem(event.target);
  });
})();

(function () {
  var WATERMARK_SCOPE_SELECTOR = [
    '.nh-watermark-scope',
    '.nh-hero__media',
    '.nh-collection-hero__media',
    '.product-card__media',
    '.nh-collection-tile__media',
    '.nh-collection-card__image',
    '.nh-story-tile__media',
    '.nh-spotlight-block__image',
    '.nh-instagram-card__link',
    '.nh-instagram-card__embed-wrap',
    '.nh-press-card__media',
    '.nh-review-card__photo',
    '.nh-b2b__hero-media',
    '.nh-b2b-category__media',
    '.nh-pdp__media-main',
    '.nh-pdp__media-tile',
    '.nh-pdp-lightbox__dialog',
    '.nh-quick-view__image-wrap',
    '.article-card__media',
    '.article-view__image',
    '.cart-item__media'
  ].join(', ');

  function isProtectedMediaTarget(target) {
    if (!target || !target.closest) {
      return false;
    }

    var mediaNode = target.closest('img, video');
    if (mediaNode) {
      return true;
    }

    var anchorNode = target.closest('a');
    return !!(anchorNode && anchorNode.querySelector('img, video'));
  }

  function hardenMedia(scope) {
    var root = scope || document;
    var media = root.querySelectorAll('img, video');

    media.forEach(function (node) {
      node.setAttribute('draggable', 'false');
      node.setAttribute('oncontextmenu', 'return false;');
    });
  }

  function applyWatermarkScopes(scope) {
    if (!document.body || !document.body.classList.contains('nh-watermark-enabled')) {
      return;
    }

    var root = scope || document;
    var images = root.querySelectorAll('main img, .nh-quick-view img, .nh-pdp-lightbox img');

    images.forEach(function (image) {
      if (!image || !image.closest) {
        return;
      }

      if (image.closest('header, .site-header, footer, .site-footer, [data-no-watermark], .payment-icons')) {
        return;
      }

      var scopeNode = image.closest(WATERMARK_SCOPE_SELECTOR);

      if (!scopeNode) {
        var parent = image.parentElement;
        if (parent && parent.childElementCount === 1) {
          scopeNode = parent;
        }
      }

      if (!scopeNode || scopeNode.classList.contains('nh-watermark-ignore')) {
        return;
      }

      scopeNode.classList.add('nh-watermark-scope');
    });
  }

  function initMediaProtection(root) {
    var scope = root || document;
    applyWatermarkScopes(scope);

    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    hardenMedia(scope);
  }

  document.addEventListener(
    'contextmenu',
    function (event) {
      if (isProtectedMediaTarget(event.target)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      if (isProtectedMediaTarget(event.target)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'selectstart',
    function (event) {
      if (isProtectedMediaTarget(event.target)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'mousedown',
    function (event) {
      if (event.button === 2 && isProtectedMediaTarget(event.target)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var key = (event.key || '').toLowerCase();
      var shouldProtect =
        isProtectedMediaTarget(event.target) ||
        (document.body && document.body.classList.contains('nh-watermark-enabled'));
      if (shouldProtect && (event.ctrlKey || event.metaKey) && ['s', 'u', 'p'].indexOf(key) !== -1) {
        event.preventDefault();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMediaProtection(document);
    });
  } else {
    initMediaProtection(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMediaProtection(event.target);
  });
})();

(function () {
  var STORAGE_KEY = 'nh-theme-mode';
  var root = document.documentElement;
  var themeColorMeta = document.querySelector('meta[name="theme-color"]');
  var lightThemeColor = themeColorMeta ? themeColorMeta.getAttribute('content') || '#faf8f4' : '#faf8f4';
  var darkThemeColor = '#090806';

  function readStoredMode() {
    try {
      return window.localStorage ? window.localStorage.getItem(STORAGE_KEY) : null;
    } catch (error) {
      return null;
    }
  }

  function storeMode(mode) {
    try {
      if (window.localStorage) {
        window.localStorage.setItem(STORAGE_KEY, mode);
      }
    } catch (error) {}
  }

  function syncToggleUi(isDark) {
    var toggles = document.querySelectorAll('[data-theme-toggle]');

    toggles.forEach(function (toggle) {
      var label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
      toggle.setAttribute('aria-pressed', String(isDark));
      toggle.setAttribute('aria-label', label);

      var labelNode = toggle.querySelector('[data-theme-toggle-label]');
      if (labelNode) {
        labelNode.textContent = label;
      }
    });
  }

  function applyMode(mode) {
    var isDark = mode === 'dark';
    root.classList.toggle('theme-dark-mode', isDark);

    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', isDark ? darkThemeColor : lightThemeColor);
    }

    syncToggleUi(isDark);
  }

  function initThemeModeToggle() {
    applyMode(readStoredMode() === 'dark' ? 'dark' : 'light');

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-theme-toggle]');
      if (!toggle) {
        return;
      }

      event.preventDefault();
      var nextMode = root.classList.contains('theme-dark-mode') ? 'light' : 'dark';
      storeMode(nextMode);
      applyMode(nextMode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThemeModeToggle);
  } else {
    initThemeModeToggle();
  }
})();

(function () {
  var loader = document.querySelector('[data-page-loader]');
  if (!loader) {
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    if (document.body) {
      document.body.classList.remove('nh-page-loading');
    }
    loader.remove();
    return;
  }

  var loaderBar = loader.querySelector('[data-page-loader-bar]');
  var loaderPercent = loader.querySelector('[data-page-loader-percent]');
  var sequenceTimers = [];
  var startedAt = Date.now();
  var hasFinished = false;
  var minimumVisibleTime = 520;

  function setProgress(value) {
    if (loaderBar) {
      loaderBar.style.width = value + '%';
    }

    if (loaderPercent) {
      loaderPercent.textContent = value + '%';
    }
  }

  function clearSequenceTimers() {
    sequenceTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    sequenceTimers = [];
  }

  function completeLoader() {
    if (hasFinished) {
      return;
    }

    hasFinished = true;
    clearSequenceTimers();

    var elapsed = Date.now() - startedAt;
    var waitTime = Math.max(0, minimumVisibleTime - elapsed);

    window.setTimeout(function () {
      setProgress(100);

      window.setTimeout(function () {
        loader.classList.add('is-hidden');
        if (document.body) {
          document.body.classList.remove('nh-page-loading');
        }

        window.setTimeout(function () {
          if (loader && loader.parentNode) {
            loader.parentNode.removeChild(loader);
          }
        }, 320);
      }, 120);
    }, waitTime);
  }

  setProgress(20);
  sequenceTimers.push(
    window.setTimeout(function () {
      if (!hasFinished) {
        setProgress(60);
      }
    }, 120)
  );
  sequenceTimers.push(
    window.setTimeout(function () {
      if (!hasFinished) {
        setProgress(80);
      }
    }, 260)
  );

  if (document.readyState === 'complete') {
    completeLoader();
  } else {
    window.addEventListener('load', completeLoader, { once: true });
    document.addEventListener('readystatechange', function () {
      if (document.readyState === 'complete') {
        completeLoader();
      }
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        completeLoader();
      }
    });

    window.setTimeout(completeLoader, 3600);
  }
})();

window.__nhCatalogGlobalInit = true;

(function () {
  function escapeCatalogHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      switch (char) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        case '\'':
          return '&#39;';
        default:
          return char;
      }
    });
  }

  function updateCatalogCount(countNode, checkboxes) {
    if (!countNode) {
      return;
    }

    var selected = checkboxes.filter(function (checkbox) {
      return checkbox.checked;
    }).length;

    countNode.textContent = selected + ' product' + (selected === 1 ? '' : 's') + ' selected';
  }

  function getSelectedCatalogItems(checkboxes) {
    return checkboxes
      .filter(function (checkbox) {
        return checkbox.checked;
      })
      .map(function (checkbox) {
        return checkbox.closest('[data-catalog-item]');
      })
      .filter(Boolean);
  }

  function updateCatalogRequestStatus(statusNode, message, isError) {
    if (!statusNode) {
      return;
    }

    statusNode.hidden = !message;
    statusNode.textContent = message || '';
    statusNode.classList.toggle('nh-b2b-catalog__request-status--error', !!message && isError !== false);
    statusNode.classList.toggle('nh-b2b-catalog__request-status--success', !!message && isError === false);
  }

  function buildCatalogPdfMarkup(selectedItems, config) {
    return selectedItems
      .map(function (item) {
        var title = escapeCatalogHTML(item.getAttribute('data-title'));
        var vendor = escapeCatalogHTML(item.getAttribute('data-vendor'));
        var productUrl = escapeCatalogHTML(item.getAttribute('data-url'));
        var image = escapeCatalogHTML(item.getAttribute('data-image'));
        var sku = escapeCatalogHTML(item.getAttribute('data-sku'));
        var summary = escapeCatalogHTML(item.getAttribute('data-summary'));
        var watermarkLogo = escapeCatalogHTML(config.watermarkLogo || '');
        var watermarkMarkup = watermarkLogo
          ? '<div class="catalog-item__wm"><img src="' +
            watermarkLogo +
            '" alt="" aria-hidden="true"></div>'
          : '<div class="catalog-item__wm catalog-item__wm--text" aria-hidden="true">' +
            escapeCatalogHTML(config.watermarkText || '') +
            '</div>';

        return (
          '<article class="catalog-item">' +
          '<div class="catalog-item__media">' +
          (image ? '<img src="' + image + '" alt="' + title + '">' : '<div class="catalog-item__placeholder"></div>') +
          watermarkMarkup +
          '</div>' +
          '<div class="catalog-item__body">' +
          '<h3>' +
          title +
          '</h3>' +
          (vendor ? '<p><strong>Brand:</strong> ' + vendor + '</p>' : '') +
          '<p><strong>Price:</strong> ' +
          escapeCatalogHTML(config.quoteLabel || 'Get Quote') +
          '</p>' +
          (sku ? '<p><strong>SKU:</strong> ' + sku + '</p>' : '') +
          (summary ? '<p>' + summary + '</p>' : '') +
          (productUrl ? '<p><a href="' + productUrl + '">' + productUrl + '</a></p>' : '') +
          '</div>' +
          '</article>'
        );
      })
      .join('');
  }

  function openCatalogPdf(selectedItems, config) {
    if (!selectedItems.length) {
      window.alert('Select at least one product for the catalog PDF.');
      return;
    }

    var productCards = buildCatalogPdfMarkup(selectedItems, config);
    var generatedOn = new Date().toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    var pdfWindow = window.open('', '_blank');

    if (!pdfWindow) {
      window.alert('Please allow popups to download the PDF catalog.');
      return;
    }

    var doc =
      '<!doctype html>' +
      '<html>' +
      '<head>' +
      '<meta charset="utf-8">' +
      '<title>' +
      escapeCatalogHTML(config.catalogTitle || 'B2B Product Catalog') +
      '</title>' +
      '<style>' +
      '@page{size:A4;margin:12mm}' +
      '*{box-sizing:border-box}' +
      'body{margin:0;font-family:Arial,sans-serif;color:#111}' +
      '.catalog-header{margin-bottom:14px;border-bottom:1px solid #ddd;padding-bottom:10px}' +
      '.catalog-header h1{margin:0 0 6px;font-size:24px}' +
      '.catalog-header p{margin:0;font-size:12px;color:#444}' +
      '.catalog-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}' +
      '.catalog-item{border:1px solid #ddd;border-radius:10px;overflow:hidden;break-inside:avoid}' +
      '.catalog-item__media{position:relative;height:210px;background:#f3f0ea;display:flex;align-items:center;justify-content:center;padding:8px}' +
      '.catalog-item__media img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;display:block;background:#fff;position:relative;z-index:1;-webkit-user-drag:none;user-select:none;-webkit-touch-callout:none}' +
      '.catalog-item__placeholder{width:100%;height:100%;background:#ebe7df}' +
      '.catalog-item__wm{position:absolute;inset:0;z-index:2;pointer-events:none;display:flex;align-items:center;justify-content:center;opacity:.18}' +
      '.catalog-item__wm img{max-width:74%;max-height:72%;width:auto;height:auto;object-fit:contain;background:transparent}' +
      '.catalog-item__wm--text{font-size:22px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#111}' +
      '.catalog-item__body{padding:10px}' +
      '.catalog-item__body h3{margin:0 0 6px;font-size:16px;line-height:1.2}' +
      '.catalog-item__body p{margin:0 0 5px;font-size:12px;line-height:1.5;word-break:break-word}' +
      '.catalog-item__body a{color:#111;text-decoration:underline}' +
      '@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}' +
      '</style>' +
      '</head>' +
      '<body>' +
      '<header class="catalog-header">' +
      '<h1>' +
      escapeCatalogHTML(config.catalogTitle || 'B2B Product Catalog') +
      '</h1>' +
      '<p>Generated on ' +
      escapeCatalogHTML(generatedOn) +
      ' | ' +
      selectedItems.length +
      ' product' +
      (selectedItems.length === 1 ? '' : 's') +
      '</p>' +
      '</header>' +
      '<section class="catalog-grid">' +
      productCards +
      '</section>' +
      '<script>' +
      "document.addEventListener('contextmenu',function(event){event.preventDefault();});" +
      "document.addEventListener('dragstart',function(event){if(event.target&&event.target.tagName==='IMG'){event.preventDefault();}});" +
      "document.addEventListener('selectstart',function(event){if(event.target&&event.target.tagName==='IMG'){event.preventDefault();}});" +
      "document.addEventListener('keydown',function(event){var key=(event.key||'').toLowerCase();if((event.ctrlKey||event.metaKey)&&['s','u','p'].indexOf(key)!==-1){event.preventDefault();}});" +
      "window.addEventListener('load',function(){document.querySelectorAll('img').forEach(function(img){img.setAttribute('draggable','false');img.setAttribute('oncontextmenu','return false;');});});" +
      '<\/script>' +
      '</body>' +
      '</html>';

    pdfWindow.document.open();
    pdfWindow.document.write(doc);
    pdfWindow.document.close();

    window.setTimeout(function () {
      pdfWindow.focus();
      pdfWindow.print();
    }, 260);
  }

  function initSingleCatalog(root) {
    if (!root || root.getAttribute('data-catalog-init') === 'true') {
      return;
    }

    root.setAttribute('data-catalog-init', 'true');

    var expectedUser = (root.getAttribute('data-catalog-username') || '').trim();
    var expectedPassword = root.getAttribute('data-catalog-password') || '';
    var authRequired = expectedUser !== '' || expectedPassword !== '';
    var catalogTitle = root.getAttribute('data-pdf-title') || 'B2B Product Catalog';
    var quoteLabel = root.getAttribute('data-quote-label') || 'Get Quote';
    var watermarkLogoRaw = root.getAttribute('data-watermark-logo') || '';
    var watermarkText = root.getAttribute('data-watermark-text') || 'HOLLY ELMS';
    var requestFormId = root.getAttribute('data-request-form-id') || '';
    var unlockKey = root.getAttribute('data-catalog-unlock-key') || ('nh-b2b-catalog-unlock::' + (root.id || 'default'));
    var gate = root.querySelector('[data-catalog-gate]');
    var content = root.querySelector('[data-catalog-content]');
    var gateForm = root.querySelector('[data-catalog-form]');
    var userInput = root.querySelector('[data-catalog-user-input]');
    var passInput = root.querySelector('[data-catalog-pass-input]');
    var gateError = root.querySelector('[data-catalog-error]');
    var countNode = root.querySelector('[data-catalog-count]');
    var selectAllButton = root.querySelector('[data-catalog-select-all]');
    var clearButton = root.querySelector('[data-catalog-clear]');
    var downloadButton = root.querySelector('[data-catalog-download]');
    var requestSubmitButton = root.querySelector('[data-catalog-request-submit]');
    var requestNameInput = root.querySelector('[data-catalog-request-name]');
    var requestEmailInput = root.querySelector('[data-catalog-request-email]');
    var requestCompanyInput = root.querySelector('[data-catalog-request-company]');
    var requestBodyInput = root.querySelector('[data-catalog-request-body]');
    var requestStatus = root.querySelector('[data-catalog-request-status]');
    var requestForm = requestFormId ? document.getElementById(requestFormId) : root.querySelector('.nh-b2b-catalog__request-form');
    var checkboxes = Array.from(root.querySelectorAll('[data-catalog-checkbox]'));
    var unlockedUser = expectedUser;

    if (requestForm && !root.contains(requestForm)) {
      requestForm = null;
    }

    function unlockCatalog() {
      if (gate) {
        gate.hidden = true;
      }
      if (content) {
        content.hidden = false;
      }
      root.classList.add('is-unlocked');

      try {
        window.localStorage.setItem(unlockKey, '1');
      } catch (storageError) {}
    }

    if (!authRequired) {
      unlockCatalog();
    } else {
      try {
        if (window.localStorage.getItem(unlockKey) === '1') {
          unlockCatalog();
        }
      } catch (storageError) {}
    }

    if (gateForm) {
      gateForm.addEventListener('submit', function (event) {
        event.preventDefault();

        var enteredUser = userInput ? userInput.value.trim() : '';
        var enteredPassword = passInput ? passInput.value : '';
        var userValid = expectedUser === '' || enteredUser.toLowerCase() === expectedUser.toLowerCase();
        var passValid = expectedPassword === '' || enteredPassword === expectedPassword;

        if (userValid && passValid) {
          if (gateError) {
            gateError.hidden = true;
          }
          unlockedUser = enteredUser || expectedUser;
          unlockCatalog();
          updateCatalogCount(countNode, checkboxes);
        } else if (gateError) {
          gateError.hidden = false;
        }
      });
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        updateCatalogCount(countNode, checkboxes);
      });
    });
    updateCatalogCount(countNode, checkboxes);

    if (selectAllButton) {
      selectAllButton.addEventListener('click', function () {
        checkboxes.forEach(function (checkbox) {
          checkbox.checked = true;
        });
        updateCatalogCount(countNode, checkboxes);
      });
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        checkboxes.forEach(function (checkbox) {
          checkbox.checked = false;
        });
        updateCatalogCount(countNode, checkboxes);
      });
    }

    if (downloadButton) {
      downloadButton.addEventListener('click', function () {
        openCatalogPdf(getSelectedCatalogItems(checkboxes), {
          catalogTitle: catalogTitle,
          quoteLabel: quoteLabel,
          watermarkLogo: watermarkLogoRaw,
          watermarkText: watermarkText
        });
      });
    }

    if (requestSubmitButton && requestForm) {
      requestSubmitButton.addEventListener('click', function (event) {
        var selectedItems = getSelectedCatalogItems(checkboxes);

        if (!selectedItems.length) {
          event.preventDefault();
          updateCatalogRequestStatus(
            requestStatus,
            'Select at least one product before sending your quote request.',
            true
          );
          return;
        }

        updateCatalogRequestStatus(requestStatus, '', false);

        if (typeof requestForm.requestSubmit === 'function') {
          event.preventDefault();
          requestForm.requestSubmit();
        }
      });
    }

    if (requestForm) {
      requestForm.addEventListener('submit', function (event) {
        var selectedItems = getSelectedCatalogItems(checkboxes);

        if (!selectedItems.length) {
          event.preventDefault();
          updateCatalogRequestStatus(
            requestStatus,
            'Select at least one product before sending your quote request.',
            true
          );
          return;
        }

        if (!requestBodyInput) {
          return;
        }

        var requesterName = requestNameInput ? requestNameInput.value.trim() : '';
        var requesterEmail = requestEmailInput ? requestEmailInput.value.trim() : '';
        var requesterCompany = requestCompanyInput ? requestCompanyInput.value.trim() : '';
        var viewerLogin = unlockedUser || expectedUser || 'Not provided';
        var generatedOn = new Date().toLocaleString();
        var productLines = selectedItems
          .map(function (item, index) {
            var title = item.getAttribute('data-title') || '';
            var sku = item.getAttribute('data-sku') || '';
            var url = item.getAttribute('data-url') || '';
            var vendor = item.getAttribute('data-vendor') || '';
            return (
              index +
              1 +
              '. ' +
              title +
              ' | Vendor: ' +
              vendor +
              ' | SKU: ' +
              sku +
              ' | Price: ' +
              quoteLabel +
              ' | URL: ' +
              url
            );
          })
          .join('\n');

        requestBodyInput.value = [
          'Catalog: ' + catalogTitle,
          'Requested on: ' + generatedOn,
          'Catalog login used: ' + viewerLogin,
          'Name: ' + requesterName,
          'Email: ' + requesterEmail,
          'Company: ' + (requesterCompany || 'Not provided'),
          '',
          'Selected products:',
          productLines
        ].join('\n');

        updateCatalogRequestStatus(requestStatus, '', false);
      });
    }
  }

  function initCatalogs(root) {
    var scope = root || document;
    var catalogs = scope.querySelectorAll('[data-nh-catalog-root]');

    catalogs.forEach(function (catalogRoot) {
      initSingleCatalog(catalogRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCatalogs(document);
    });
  } else {
    initCatalogs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCatalogs(event.target);
  });
})();

// Cursor image reveal effect
(function () {
  function initCursorReveal() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!document.body) return;

    var cursorEl = document.createElement('div');
    cursorEl.className = 'he-cursor-image';
    var cursorImg = document.createElement('img');
    cursorEl.appendChild(cursorImg);
    document.body.appendChild(cursorEl);

    var mouseX = 0, mouseY = 0;
    var currentX = 0, currentY = 0;

    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    function lerp(a, b, t) { return a + (b - a) * t; }

    function animate() {
      currentX = lerp(currentX, mouseX, 0.1);
      currentY = lerp(currentY, mouseY, 0.1);
      cursorEl.style.left = currentX + 'px';
      cursorEl.style.top = currentY + 'px';
      requestAnimationFrame(animate);
    }

    animate();

    function getProductImage(card) {
      var img = card.querySelector('img');
      if (!img) return null;
      return img.src || img.dataset.src || null;
    }

    function onEnter() {
      var src = getProductImage(this);
      if (!src) return;
      cursorImg.src = src;
      cursorEl.classList.add('is-visible');
    }

    function onLeave() {
      cursorEl.classList.remove('is-visible');
    }

    function initCards() {
      document.querySelectorAll('article.product-card').forEach(function (card) {
        if (card.dataset.cursorInit) return;
        card.dataset.cursorInit = 'true';
        card.addEventListener('mouseenter', onEnter.bind(card));
        card.addEventListener('mouseleave', onLeave);
      });
    }

    initCards();

    var observer = new MutationObserver(function () {
      initCards();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCursorReveal);
  } else {
    initCursorReveal();
  }
})();